export const marketplaceInsights = {
  SearchVerticalCategoryInsightsReport: {
    mandatory: [],
    default: [
      'L1Vertical',
      'L2Vertical',
      'L3Vertical',
      'Country',
      'SearchesIndexed',
      'ClicksIndexed',
      'WeekStartingMonday',
      'WoWSearches',
      'WoWClicks',
      'MoMSearches',
      'MoMClicks',
      'YoYLast1WeekSearches',
      'YoYLast1WeekClicks',
      'YoYLast4WeeksSearches',
      'YoYLast4WeeksClicks',
      'SearchesPeekWeek',
      'ClicksPeekWeek',
    ],
  },
  SearchVerticalCategoryClickShareReport: {
    mandatory: [],
    default: [
      'AccountName',
      'L1Vertical',
      'L2Vertical',
      'L3Vertical',
      'Country',
      'WeekStartingMonday',
      'MarketplaceClickCoverage',
      'ProportionOfSpend',
    ],
  },
};
